import React, { useEffect, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Card from "components/card";
import Box from "@mui/material/Box";
import axios from "../../../../api/axios";
import ComplaintDetailsModal from "./ComplaintDetailsModal";

const ComplaintsTable = ({ tableData, statusField = "policeStatus" }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedComplaintDescription, setSelectedComplaintDescription] =
    useState("");

  const fetchReportDetails = async (reportId, complaintId) => {
    const token = "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");
    try {
      const response = await axios.get(`/api/reports/report/${reportId}`, {
        headers: { Authorization: token, "Content-Type": "application/json" },
      });
      const reportWithComplaintId = { ...response.data, complaintId };
      setSelectedReport(reportWithComplaintId);
      setSelectedComplaintDescription(response.data.description);
    } catch (err) {
      console.error("Error fetching report details", err);
    }
  };

  useEffect(() => {
    setRows(tableData);
    setLoading(false);
  }, [tableData]);

  // ✅ normalize backend enums to readable strings
  const statusMap = { 0: "Pending", 1: "Approved", 2: "Refused" };

  const columns = useMemo(
    () => [
      {
        field: "reportName",
        headerName: "Nr. i Raportit",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "reportDate",
        headerName: "Data e Raportit",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        valueFormatter: ({ value }) =>
          new Date(value).toLocaleDateString("en-US"),
      },
      {
        field: "category",
        headerName: "Kategoria",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "createdAt",
        headerName: "Data e ankesës",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        valueFormatter: ({ value }) =>
          new Date(value).toLocaleDateString("en-US"),
      },
      {
        field: statusField,
        headerName: "Statusi",
        flex: 1,
        minWidth: 140,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          const val = params.row[statusField];

          // ✅ Map to Albanian
          const statusMap = {
            0: "Në pritje",
            1: "Aprovuar",
            2: "Refuzuar",
          };

          const label = statusMap[val] ?? "I panjohur";

          // ✅ Apply correct colors based on Albanian words
          const cls =
            label === "Aprovuar"
              ? "bg-green-100 text-green-800"
              : label === "Refuzuar"
              ? "bg-red-100 text-red-800"
              : "bg-yellow-100 text-yellow-800";

          return (
            <span className={`rounded px-2 py-1 text-xs font-semibold ${cls}`}>
              {label}
            </span>
          );
        },
      },

      {
        field: "details",
        headerName: "Detajet",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <label
            htmlFor="my-modal-5"
            className="rounded-xl bg-brand-500 px-[15px] py-[8px] text-base font-medium text-white transition duration-200 hover:bg-brand-700 active:bg-brand-800"
            onClick={() => {
              const normalized =
                statusMap[params.row[statusField]] || "Unknown";
              setSelectedStatus(normalized); // ✅ always "Pending", "Approved", or "Refused"
              fetchReportDetails(params.row.reportId, params.row.id);
            }}
          >
            Detajet
          </label>
        ),
      },
    ],
    [statusField]
  );

  return (
    <>
     <ComplaintDetailsModal
  selectedReport={selectedReport}
  complaintDescription={selectedComplaintDescription}
  complaintStatus={selectedStatus}
    adminName={localStorage.getItem("name")} 
  onActionCompleted={(complaintId, newStatus) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === complaintId ? { ...row, [statusField]: newStatus } : row
      )
    );
  }}
/>

      <Card extra={"w-full sm:overflow-auto p-4"}>
        <Box>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            autoHeight
            pageSize={10}
            rowsPerPageOptions={[10]}
            loading={loading}
            disableColumnMenu
            disableSelectionOnClick
            localeText={{ noRowsLabel: "No complaints found" }}
            className="text-black dark:text-white"
          />
        </Box>
      </Card>
    </>
  );
};

export default ComplaintsTable;
